<mat-sidenav-container hasBackdrop="true" class="mx-auto p-0 -mt-px flex-auto border-t pt-0 sm:pt-0">
  <div class="mx-auto flex w-full flex-wrap p-4">
    <div class="flex flex-col sm:flex-row w-full mb-4 items-center justify-between">
      <div>
        <div class="flex items-center gap-1">
          <div hoverMenu hoverDelay="50" #hoverDirective="hoverMenu" [matMenuTriggerFor]="infoMenu">
            <button mat-icon-button color="primary">
              <mat-icon svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
            </button>
          </div>
          <mat-menu [hasBackdrop]="false" [overlapTrigger]="false" class="w-full" #infoMenu="matMenu">
            <div class="p-4">
              <p>
                Qué tanto convierten las visitas en ventas.
                Compara visitas planeadas vs. realizadas y
                ventas logradas. Úsalo para identificar
                dónde se visita pero no se vende, y
                ajustar la estrategia.
              </p>
            </div>
          </mat-menu>
          <h2 class="text-xl font-semibold leading-8 tracking-tight">
            Seguimiento de Visita
          </h2>
        </div>
        <div class="text-sm text-secondary font-medium tracking-tight">
          Visualiza la agrupación del <b>viaje</b>, la
          duración y validación por GPS en los procesos de <b>visita</b> en los
          <b>socios de negocio</b>.
        </div>
      </div>
      <div class="relative flex flex-0 flex-col px-4 py-2 sm:flex-row sm:items-center sm:justify-between">
        <div class="flex shrink-0">
          <!-- Title -->
          <!--<div class="text-3xl font-extrabold tracking-tight">Reporte de Visitas</div> -->
        </div>
        <!-- Actions -->
        <div class="mt-6 flex shrink-0 items-center space-x-3 sm:ml-4 sm:mt-0">

        </div>
      </div>
    </div>
    <div class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl shadow xl:col-span-2 dark:bg-transparent">
      <!-- Main Content (Table and Paginator) -->
      <div class="pt-1 mx-6">
        <!-- Tabla -->
        <div class="flex flex-col flex-1 min-h-0 overflow-auto" style="height: calc(100vh - 270px)">
          <!-- Header -->
          <div class="overflow-auto flex-1 dark:bg-gray-900">
            <table class="w-full bg-transparent" mat-table [dataSource]="dataSource" matSort
              (matSortChange)="changeSort($event)" matSortDisableClear multiTemplateDataRows>
              <ng-container matColumnDef="det">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let element">
                  <button mat-icon-button (click)="toggleDetails(element)" style="margin-left: 10px">
                    <mat-icon class="icon-size-5" [svgIcon]="
                        selectedTrip?.trip?._id === element?.trip?._id
                          ? 'heroicons_solid:chevron-up'
                          : 'heroicons_solid:chevron-down'
                      "></mat-icon>
                  </button>
                </td>
              </ng-container>

              <ng-container matColumnDef="map">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left first-col table-tittle"></th>
                <td mat-cell *matCellDef="let element" class="text-left first-col table-text">
                  <button mat-icon-button (click)="openModal(element, 'H')" color="primary" matTooltip="Ver mapa">
                    <mat-icon svgIcon="heroicons_outline:map"></mat-icon>
                  </button>
                </td>
              </ng-container>
              <ng-container matColumnDef="trip">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left first-col table-tittle">
                  Viaje
                </th>
                <td mat-cell *matCellDef="let element" class="text-secondary text-center first-col table-text">
                  <span class="table-text-code" *ngIf="getCode(element?.trip) as code">{{ code }}<br /></span>
                  <div class="flex items-center px-3 cursor-pointer" [ngClass]="{ underline: element?.trip?.id }"
                    (click)="element?.trip?.id && goToTravel(element)"
                    [matTooltip]="element?.trip.id ? 'Ir al viaje' : ''">
                    <span>{{ element?.trip?.id ? element.trip.id : "-" }}</span>
                    <mat-icon *ngIf="element?.trip.id" class="ml-2 icon-size-3 hover:animate-bounce"
                      [svgIcon]="'heroicons_outline:rocket-launch'" style="color: rgb(0, 0, 0)"></mat-icon>
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="routeUser">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left first-col table-tittle">
                  Ruta - Usuario
                </th>
                <td mat-cell *matCellDef="let element" class="text-left first-col table-text">
                  <div class="table-text-m" *ngIf="element.subRoute || element.user; else noData">
                    <app-user-route-display [routeData]="{
                        routeName: element?.subRoute?.name ?? '-',
                        externalKeys: { code: element?.subRoute?.externalKeys?.code ?? element?.subRoute?.model ?? '-' }
                      }" [userData]="{name: element.user}"
                      [responsibleData]="{name: element?.responsibleBusinessPartner?.name ?? '-', personNumber: element?.responsibleBusinessPartner?.personNumber ?? '-', externalKeys: { code: element?.responsibleBusinessPartner?.externalKeys?.code ?? '-' }}"
                      [displayMode]="'detailed'" [showRouteCode]="true" [showUser]="true" [showResponsible]="true">
                    </app-user-route-display>
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="date">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left first-col table-tittle">
                  Día
                </th>
                <td mat-cell *matCellDef="let element" class="text-left first-col table-text">
                  <div class="text-content">
                    <span class="font-semibold">{{ element?.day }}<br></span>
                    <span class="font-descrip">{{ element?.trip?.dateHourStart | date: "dd-MM-yyyy" }}</span>
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="visitsTotal">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left first-col table-tittle">
                  Visita Total
                </th>
                <td mat-cell *matCellDef="let element" class="first-col table-text text-left">
                  <div class="text-content">
                    {{ element?.visitsIndicator?.VisitDay }}
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="visitsDay">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left first-col table-tittle">
                  Visita Realizada
                </th>
                <td mat-cell *matCellDef="let element" class="first-col table-text text-left">
                  <div class="text-content">
                    {{ element?.visitsIndicator?.VisitDay }}
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="visitsPending">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left first-col table-tittle">
                  Visita Pendiente
                </th>
                <td mat-cell *matCellDef="let element" class="first-col table-text text-left">
                  <div class="text-content">
                    {{ element?.visitsIndicator?.VisitDay }}
                  </div>
                </td>
              </ng-container>

              <ng-container matColumnDef="expandedDetail">
                <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length">
                  <tr *ngIf="selectedTrip?.trip?._id === element?.trip?._id" class="details-row">
                    <td [attr.colspan]="displayedColumns.length">
                      <ng-container *ngTemplateOutlet="
                          rowDetailsTemplate;
                          context: { $implicit: row }
                        "></ng-container>
                    </td>
                  </tr>
                </td>
              </ng-container>

              <!-- Header Row -->
              <tr mat-header-row *matHeaderRowDef="displayedColumns"
                class="sticky top-0 z-10 bg-white dark:bg-gray-900"></tr>
              <!-- Fila principal -->
              <tr mat-row *matRowDef="let element; columns: displayedColumns" class="border-b"
                [class.table-expanded-row]="
                  selectedTrip?.trip?._id === element?.trip?._id
                "></tr>
              <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="table-detail-row"></tr>
            </table>
          </div>
          <div *ngIf="this.dataSource.length === 0" class="border-t p-8 text-center text-1xl sm:p-10">
            Lo sentimos, no hay registros para mostrar.
          </div>
        </div>

        <!-- Paginación -->
        <div class="flex-shrink-0 bg-gray-100 dark:bg-gray-900 border-b">
          <mat-paginator class="z-10" [pageSizeOptions]="[50, 100, 150, 200]" showFirstLastButtons [length]="totalItems"
            [pageSize]="pageSize" (page)="onPageChange($event)"></mat-paginator>
        </div>
      </div>
    </div>
  </div>
  <!-- Modales -->
  <ng-template #rowDetailsTemplate let-order>
    <div class="overflow-hidden">
      <div class="flex border-b">
          <div class="flex flex-col px-3 sm:flex-row">
            <div class="flex flex-auto flex-wrap">
              <div class="p-2 flex w-full flex-col">
                <table class="w-width min-w-500 overflow-y-visible mat-elevation-z" mat-table
                  [dataSource]="dataSourceDetail" matSort matSortActive="dateTimeStart">
                  <ng-container matColumnDef="geo">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                      class="text-left first-col table-tittle w-min-detail"></th>
                    <td mat-cell *matCellDef="let detail" class="text-left first-col table-text">
                      <mat-icon color="primary" (click)="openModal(detail, 'D')" [matTooltip]="
                          detail?.geoPoint.length > 0
                            ? 'Ver'
                            : 'No hay ubicación'
                        " class="pointer-icon" matBadgeColor="accent" matBadgeSize="small"
                        aria-hidden="false">place</mat-icon>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="bPartner">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-left first-col table-tittle">
                      Socio de Negocio
                    </th>
                    <td mat-cell *matCellDef="let detail" class="px-6 text-left first-col table-text">
                      <p class="table-text-m text-uppercase">
                        <span class="font-bold text-xs">{{
                          detail?.shipToExternalKeyCode
                          }}</span><br />
                        {{ detail?.shipToName }}
                      </p>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="visit">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-left first-col table-tittle">
                      Visita
                    </th>
                    <td mat-cell *matCellDef="let detail" class="px-6 text-left first-col table-text">
                      {{ detail?.reasonForVisitName }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="documentNumber">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-left first-col table-tittle">
                      Nro. Documento
                    </th>
                    <td mat-cell *matCellDef="let detail" class="px-6 text-left first-col table-text">
                      {{
                      detail.serials &&
                      detail.serials.trim() !== "" &&
                      detail.serials !== "null"
                      ? detail.serials
                      : ""
                      }}
                    </td>
                  </ng-container>
                  <!-- Inicio -->
                  <ng-container matColumnDef="dateTimeStart">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-left">
                      Duración
                    </th>
                    <td mat-cell *matCellDef="let data" class="text-left text-sm">
                      <p class="pr-2">
                        <span class="font-semibold" [matTooltip]="'Fecha Inicio'">FI:
                        </span>
                        {{
                        data?.dateTimeStart
                        ? (data?.dateTimeStart | date: "dd-MM-yyyy HH:mm")
                        : "-"
                        }}
                      </p>
                      <p class="pr-2">
                        <span class="font-semibold" [matTooltip]="'Fecha Fin'">FF:
                        </span>
                        {{
                        data?.dateTimeEnd
                        ? (data?.dateTimeEnd | date: "dd-MM-yyyy HH:mm")
                        : "-"
                        }}
                      </p>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="duration">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-left first-col table-tittle">
                      Duración Visita
                    </th>
                    <td mat-cell *matCellDef="let detail" class="px-6 text-center first-col table-text">
                      {{ detail.duration | FormatToHour }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="location">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-left first-col table-tittle">
                      Ubicación GPS
                    </th>
                    <td mat-cell *matCellDef="let detail" class="px-6 text-left first-col table-text">
                      <p class="table-text-m text-left" style="min-width: 90px">
                        <b>APP: </b>{{ detail?.geoPoint ?? "-" }}<br />
                        <b><span>AVE:</span><br /></b>{{ detail?.address?.[0]?.geolocationPoint ?? "-" }} <br>
                        <b><span>Distancia:</span><br></b>
                        {{ detail?.distance ?? "-" }}
                      </p>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="wasTheVisitOnSite">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                      class="px-6 text-center first-col table-tittle">
                      Zona
                    </th>
                    <td mat-cell *matCellDef="let detail" class="px-6 text-center first-col table-text">
                      {{ detail.wasTheVisitOnSite ? "SI" : "NO" }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="validVisit">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                      class="px-6 text-center first-col table-tittle">
                      Visita Válida
                    </th>
                    <td mat-cell *matCellDef="let detail" class="px-6 text-center first-col table-text">
                      {{ detail.validVisit ? "SI" : "NO" }}
                    </td>
                  </ng-container>

                  <!-- Header Row -->
                  <tr mat-header-row *matHeaderRowDef="displayedColumnsDetail" class="bg-gray-100 dark:bg-gray-900">
                  </tr>
                  <!-- Fila principal -->
                  <tr mat-row *matRowDef="let row; columns: displayedColumnsDetail" class="border-b"></tr>
                </table>
              </div>
            </div>
          </div>
      </div>
    </div>
  </ng-template>

  <ng-template #noData>
    <span> - </span>
  </ng-template>

  <!-- Filtros -->
  <app-filter (onFilterEvent)="findAllWithCount()" (onCleanEvent)="onClearFilter()"
    (onPanelOpened)="onFilterPanelOpened()">
    <app-dates-filters [form]="form" [showDateCreationRange]="true"></app-dates-filters>
    <app-configuration-filters [form]="form" [company]="true" [salesOffice]="true"
      [loadData]="loadFiltersData"></app-configuration-filters>
    <app-routes-filters [form]="form" [route]="true" [loadData]="loadFiltersData"></app-routes-filters>
    <app-business-partners-filters [form]="form" [businessPartner]="true"
      [loadData]="loadFiltersData"></app-business-partners-filters>
  </app-filter>
</mat-sidenav-container>